<template>
  <div>
    <app-bar :is-login="true" @logout="logout"/>
    <side-navigation />
    <v-main id="main-content">
      <router-view />
    </v-main>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted} from "vue"
import { useStore } from "../stores/index"
import appBar from "./shared/AppBar.vue"
import sideNavigation from "./shared/SideNavigation.vue"
import { roles } from "../service/roles"

export default defineComponent({
  name: "TopPage",
  emits: ['logout'],
  components: {
    appBar,
    sideNavigation
  },
  setup() {
    // vuex
    const store = useStore()
    const role = roles()

    const logout = () =>{
      store.dispatch("signOut")
    }

    onMounted(async () => {
      if(role.isSales()){
        await store.dispatch("fetchCorporationsNestedTree")
      }
    })

    return { logout }
  }
})
</script>
